export const getStepNameSelector = (state) => state.wizardState.stepName;

export const getStepNumber = (state) => state.wizardState.currentWizardView;

export const getWizardViewDataSelector = (state) => state.wizardState.wizardViewData;

export const getWizardInitialTrayType = (state) => state.wizardState.initialTrayType;

export const getAutoA1OffsetProgress = (state) => state.wizardState.autoA1OffsetCallibrationProgress;
